export const FUNCTION_TYPES = ["Program", "Admin"];
